import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['refreshOnLoad']

  connect(){
    console.log("connected content loader controller")
    if (this.hasRefreshOnLoadTarget) {
      this.load()
    }

    const self = this
    this.element.addEventListener("refresh-content", function(e) {
      self.load(e)
    })
  }

  load() {
    const url = this.url()
    const self = this;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        this.element.innerHTML = html
        self.element.dispatchEvent(new Event("contentLoader::loaded"))
        self.postSuccessHook()
      })
  }

  url() {
    return this.data.get("url")
  }

  postSuccessHook() { }

}
